/* ToastStack.tsx — transient confirmations. */

import { useEffect, useRef } from 'react';
import { useFeedback } from './store';

export function ToastStack() {
  const { toasts, dismissToast } = useFeedback();
  const scheduled = useRef<Set<string>>(new Set());

  useEffect(() => {
    for (const t of toasts) {
      if (scheduled.current.has(t.id)) continue;
      scheduled.current.add(t.id);
      setTimeout(() => {
        dismissToast(t.id);
        scheduled.current.delete(t.id);
      }, t.ttl || 3200);
    }
  }, [toasts, dismissToast]);

  if (!toasts.length) return null;

  return (
    <div className="proto-toast-stack" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className="proto-toast" data-kind={t.kind}>
          <span
            className="seam"
            style={{ background: t.kind === 'unbound' ? 'var(--p-amber)' : 'var(--p-teal)' }}
          />
          <span>{t.text}</span>
          <span className="x" onClick={() => dismissToast(t.id)}>
            ×
          </span>
        </div>
      ))}
    </div>
  );
}
